import { Link, Typography, useTheme } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import externalLinks from 'services/routes/externalLocations';

const LegalAgreements = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Typography
      variant="body1"
      data-testid="legalText"
      sx={{
        textAlign: 'left',
        marginTop: theme.spacing(3),
        color: theme.palette.grey[400],
        '& a': {
          color: theme.palette.grey[400],
          textDecorationColor: theme.palette.grey[400],
          '&:hover': {
            color: theme.palette.primary.main,
          },
        },
        fontSize: 12,
      }}
    >
      <Trans
        i18nKey="auth:acceptLegalAgreementsText"
        t={t}
        data-testid="legalText"
      >
        <Link href={externalLinks.legal.terms.url} />
        <Link href={externalLinks.legal.privacy.url} />
        <Link href={externalLinks.legal.license.url} />
      </Trans>
    </Typography>
  );
};

export default LegalAgreements;
